import React from "react";
import App from "./../app.jsx";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Login from "../pages/auth/Login";
import Logout from "../pages/auth/Logout";
import ResetPassword from "../pages/auth/ResetPassword";
import CustomerAddEdit from "../pages/customers/CustomerAddEdit";
import CustomerProperties from "../pages/customers/CustomerProperties";
import CustomerPropertyAddEdit from "../pages/customers/CustomerPropertyAddEdit";
import Customers from "../pages/customers/Customers";
import DeliveryNoteTemplateAddEdit from "../pages/delivery_note_templates/DeliveryNoteTemplateAddEdit";
import DeliveryNoteTemplates from "../pages/delivery_note_templates/DeliveryNoteTemplates";
import DeliveryNoteAddEdit from "../pages/delivery_notes/DeliveryNoteAddEdit";
import DeliveryNoteDetails from "../pages/delivery_notes/DeliveryNoteDetails";
import DeliveryNotes from "../pages/delivery_notes/DeliveryNotes";
import Home from "../pages/home/Home";
import HomeRedirect from "../pages/home/HomeRedirect";
import InspectionCard from "../pages/inspections/InspectionCard";
import Inspections from "../pages/inspections/Inspections";
import ItemAddEdit from "../pages/items/ItemAddEdit";
import Items from "../pages/items/Items";
import ImportSettings from "../pages/settings/ImportSettings";
import Settings from "../pages/settings/Settings";
import SqlbaseSettings from "../pages/settings/SqlbaseSettings";
import TranslationSettings from "../pages/settings/TranslationSettings";
import UserSettings from "../pages/settings/UserSettings";
import UserAddEdit from "../pages/users/UserAddEdit";
import Users from "../pages/users/Users";
import WorkOrderAddEdit from "../pages/work_orders/WorkOrderAddEdit";
import WorkOrderDetails from "../pages/work_orders/WorkOrderDetails";
import WorkOrders from "../pages/work_orders/WorkOrders";
import { ProtectedRoute } from "./auth";

const AppRoute = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "",
        element: <HomeRedirect />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "sqlbase/inspections",
        element: <Inspections />,
      },
      {
        path: "sqlbase/inspections/:slug/details",
        element: <InspectionCard />,
      },
      {
        path: "delivery_notes",
        element: <DeliveryNotes />,
      },
      {
        path: "delivery_notes/add",
        element: <DeliveryNoteAddEdit />,
      },
      {
        path: "delivery_notes/:noteId/edit",
        element: <DeliveryNoteAddEdit />,
      },
      {
        path: "delivery_notes/:noteId/details",
        element: <DeliveryNoteDetails />,
      },
      {
        path: "work_orders",
        element: <WorkOrders />,
      },
      {
        path: "work_orders/add",
        element: <WorkOrderAddEdit />,
      },
      {
        path: "work_orders/:workOrderId/edit",
        element: <WorkOrderAddEdit />,
      },
      {
        path: "work_orders/:workOrderId/details",
        element: <WorkOrderDetails />,
      },
      {
        path: "items",
        element: <Items />,
      },
      {
        path: "items/add",
        element: <ItemAddEdit />,
      },
      {
        path: "items/:itemId/edit",
        element: <ItemAddEdit />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "customer_properties",
        element: <CustomerProperties />,
      },
      {
        path: "customers/add",
        element: <CustomerAddEdit />,
      },
      {
        path: "customers/:customerId/edit",
        element: <CustomerAddEdit />,
      },
      {
        path: "customer_properties/add",
        element: <CustomerPropertyAddEdit />,
      },
      {
        path: "customer_properties/:propertyId/edit",
        element: <CustomerPropertyAddEdit />,
      },
      {
        path: "delivery_note_templates",
        element: <DeliveryNoteTemplates />,
      },
      {
        path: "delivery_note_templates/add",
        element: <DeliveryNoteTemplateAddEdit />,
      },
      {
        path: "delivery_note_templates/:templateId/edit",
        element: <DeliveryNoteTemplateAddEdit />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "users/add",
        element: <UserAddEdit />,
      },
      {
        path: "users/:userId/edit",
        element: <UserAddEdit />,
      },
      {
        path: "users/me/settings",
        element: <UserSettings />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "settings/sqlbase",
        element: <SqlbaseSettings />,
      },
      {
        path: "settings/translations",
        element: <TranslationSettings />,
      },
      {
        path: "settings/imports",
        element: <ImportSettings />,
      },

      {
        path: "auth/logout",
        element: <Logout />,
      },
    ],
  },

  {
    path: "/auth",
    element: <App />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "forgot",
        element: <ForgotPassword />,
      },
      {
        path: "reset",
        element: <ResetPassword />,
      },
    ],
  },
];

export default AppRoute;
